import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import moment from 'moment'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import { bindActionCreators } from 'redux'
import * as analyticsActions from 'action/analyticsNew'
import CloseIconSVG from 'component/svgComponents/close'

const DEFAULT_PERIOD_INITIAL_VALUE = [moment().subtract(1, 'month'), moment()]

class SideFilterForm extends React.Component {
  static propTypes = {
    closeFilter: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    sendStore: PropTypes.func.isRequired,
    sendRegion: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    show: PropTypes.bool,
    isUserMatriz: PropTypes.bool,
    fetchFiltersGlobal: PropTypes.func,
    optionsBranchs: PropTypes.func,
    missionsSelectBranchs: PropTypes.array
  }

  state = {
    firstFetch: false,
    initialValue: DEFAULT_PERIOD_INITIAL_VALUE,
    values: {
      branchs: [],
      period: DEFAULT_PERIOD_INITIAL_VALUE,
    },
    prevValues: {
      branchs: [],
      period: []
    },
    sameDt: null,
    sameBranch: true
  }

  componentDidMount() {
    // this.handleSubmit()
  }

  componentDidUpdate() {
      this.verifyValuesChange()
  }

  verifyValuesChange = () => {

    const sortBranchs = (a,b) => a < b ? 1 : -1

    const {values,prevValues} = this.state
    const idListPrev = prevValues.branchs.map(branch => branch.value).sort(sortBranchs)
    const idList = values.branchs.map(branch => branch.value).sort(sortBranchs)
    const sameBranchs = JSON.stringify(idListPrev) === JSON.stringify(idList)
    if(sameBranchs && !this.state.sameBranch) this.setState({sameBranch: true})

    else if(!sameBranchs && this.state.sameBranch)  this.setState({sameBranch: false})

    if(prevValues.period.length > 0) {
      const spreadDt = [...values.period, ...prevValues.period].map(dt => dt.format('L'))

      const samePeriod = spreadDt[0] === spreadDt[2] && spreadDt[1] === spreadDt[3]

      if(samePeriod && !this.state.sameDt) this.setState({sameDt: true})

      else if(!samePeriod && this.state.sameDt)  this.setState({sameDt: false})

  }
}

  handleChange = (name, value) => {

    const { values } = this.state
    this.setState({values: {
      ...values,
      [name]: value
    }})

  }

  isBtnDisabled() {
    const { values } = this.state
    let disabled = false

    const toValidate = ['period']

    for (const field of toValidate) {
      if (
        (Array.isArray(values[field]) && values[field].length === 0) ||
        !values[field]
      ) {
        disabled = true
      }
    }

    this.setState({btnDisabled: disabled})
    return disabled
  }

  handleSubmit = () => {
    const { onSubmit, sendStore, sendRegion,  fetchFiltersGlobal} = this.props
    const { values } = this.state

    const newValues = { ...values }

    this.setState(prevState => ({
        prevValues: prevState.values
      }))

    let branchs = []

    for (const b of newValues.branchs || []) {
      if (b.idBranches) {
        branchs.push(...b.idBranches)
        branchs.push(b.value)
        if(b.length === 1) sendStore(b.value)
      } else {
        branchs.push(b.value)
        branchs.push(b.idRegion)
        sendStore(b.label)
      }
    }
    sendRegion(newValues.branchs)
    branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)

    newValues.dtBegin =
      newValues.period.length > 0 ? newValues.period[0].format() : ''
    newValues.dtEnd =
      newValues.period.length > 0 ? newValues.period[1].format() : ''
    newValues.branchs = branchs

    delete newValues.period

    onSubmit(newValues)
    fetchFiltersGlobal({branchs: values.branchs, dtBegin: newValues.dtBegin, dtEnd: newValues.dtEnd})
    if(!this.state.firstFetch) this.setState({firstFetch: true})
  }

  render() {

    const {
      translate,
      auth: { user },
      closeFilter,
      show,
      isUserMatriz,
      fetchFiltersGlobal,
      missionsSelectBranchs = []
    } = this.props

    const { values } = this.state

    const setPrevValues = (values) => {
      const newPrevValues = {...this.state.prevValues}
      newPrevValues.branchs = values
      this.setState({prevValues: newPrevValues})

      fetchFiltersGlobal(
        {branchs: values,
        dtBegin: newPrevValues.period[0].format(),
        dtEnd: newPrevValues.period[1].format()})
    }

    return (
      <div
        className={`right-filter-container irc-side-filter ${
          !show ? 'hidden' : ''
        }`}
      >
        <CloseIconSVG className="right-filter-svg" onClick={closeFilter} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>

        <div className='w-100'>
          <RegionBranchMultipleSelect
            showInternalServices
            getAllBranchs={(options) => this.props.optionsBranchs(options)}
            required
            setPrevValues={setPrevValues}
            name='branchs'
            label={`${translate('irc.store')}`}
            placeholder={translate('irc.choose-store')}
            user={user}
            translate={translate}
            onChange={(e) => this.handleChange('branchs', e.target.value)}
            value={!isUserMatriz && !missionsSelectBranchs.includes(user.title) ? [{ value: user.locationCode.padStart(4, '0') }] : values.branchs}
            disabled={!isUserMatriz && !missionsSelectBranchs.includes(user.title)}
            analyticsDetails
          />
        </div>

        <div className='w-100'>
          <NewDateIntervalInput
            user={user}
            defaultLastMonth
            required
            label={translate('field.period.hint')}
            name={'period'}
            t={translate}
            onChange={(e) => this.handleChange('period', e)}
            maxLimitDay={user.isLdapInManager ? false : parseInt(user.reportLimitDaysFilter, 10)}
          />
        </div>

        <button
          className='btn btn-primary button-full'
          onClick={this.handleSubmit}
          disabled={ this.state.sameBranch && this.state.sameDt || values.branchs.length < 1 }
          type='button'
        >
          {translate('btn.filter')}
        </button>
      </div>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  isUserMatriz: auth.isUserMatriz,
  user: auth.user
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...analyticsActions, }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SideFilterForm)

export { SideFilterForm }
